module.exports = __webpack_public_path__ + "static/media/amar.8a03271a.jpeg";